import {
  Component,
  OnInit,
  DoCheck,
  ViewChild,
  HostListener,
  AfterViewInit,
} from "@angular/core";
import { Location } from "@angular/common";
import { Router, ActivatedRoute, NavigationEnd, Routes } from "@angular/router";
import { DashboardService } from "../../services/events/dashboard.service";
import { environment } from "../../../environments/environment";
import { StorageManager } from "../../common/storage-manager.class";
import { LoginApiService } from "../../services/api/login-api.service";
import { CategoriaService } from "src/app/services/categorias/categoria";
import { Subscription } from "rxjs";
import { MessageService } from "primeng/api";
import { MenuItem } from "primeng/api";
import { ImageBaseService } from "src/app/services/imagenes/imagenes.service";
import { url, urlUpload } from "src/app/config/config";
import { logo, logoDasboard } from "src/app/config/imagenes";
import { TitleHeaderService } from "src/app/services/title-header/title.header.service";
import {
  getDocumento,
  getDocumentoFirstReport,
  rellenarMenUsuario,
} from "src/app/config/procedimientos_registros";
import { SlideMenu } from "primeng/slidemenu";
import { ColumnManagerService } from "src/app/services/column-manager/column-manager.service";
import { filter, first } from "rxjs/operators";
import { ImageConfigService } from "src/app/services/image-config/image-config.service";
import { SidenavComponent } from "./sidenav/sidenav.component";

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
  providers: [CategoriaService, MessageService, SidenavComponent],
})
export class DashboardComponent implements OnInit, DoCheck, AfterViewInit {
  @ViewChild("menu") menu_slide: SlideMenu;

  @HostListener("window:scroll", ["$event"]) // for window scroll events
  onScroll(event) {
    this.menu_slide.hide();
  }

  @ViewChild("sidenavComponent") sidenavComponent: SidenavComponent;

  // public version: string = '2.11.28';
  public version: string = environment.version;

  public items: MenuItem[];
  public calidad_imagen: string;
  public fruto_hueso: string;
  public app_stock: string;
  public app_visitas: string;
  public brcgs: string;
  enac: string;
  global_gap: string;
  ifs: string;
  igp: string;
  certificado: string;
  displayDocumentacion: boolean;
  titleDocumentacion: any;
  public url_doc: string = "";

  ngDoCheck(): void {
    this.dashboardEvent.revisarMenu();
    this.showImage();
    // this.titleAnexo = this.location.path().replace("/dashboard/", "");
    // this.titleAnexo = this.capitalize(this.titleAnexo)
  }
  capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  }
  public expression = false;
  public displayImage = false;
  public contador = 0;
  public cols: any[] = [];
  public resultado: any[] = [];
  public registros: any;
  public click: Subscription;
  public es: any;
  public categoria = "";
  public date: Date = new Date();
  public fechaCadena = "";
  public displayAnexo = false;
  public titleAnexo = "";
  public dispplayContent = false;
  public sidebarMaxWidth: number = 100;
  public isSidebarOpen: boolean = false;
  public clientHeaderDialog: string;
  public showClientDialog: boolean = false;
  //public logoUrl: string = environment.logoUrl;
  public isOnline: boolean;
  public logo: string = environment.logoUrl;
  public titleColumnManager = "";
  public titleFormManager = "";
  public displayColumnManager = false;
  public displayFormManager = false;
  public categoryColumnManager = "";
  public commentTableName: string = "";
  public popupItems = [
    /*
        {
            label: this.loginApi.getCurrentUser().nombre,
            icon: 'fa fa-user'
        },
        {separator: true},
        */
    {
      label: "Cerrar Sesión",
      icon: "fa fa-sign-out",
      command: (): void => {
        StorageManager.deleteUser();
        // localStorage.clear();
        this.router.navigate(["login"]);
      },
    },
    {
      label: "Ver " + this.version,
    },
  ];

  public user = StorageManager.getUser() || ({} as any);

  public clientes = {
    selected: null,
    filtered: [{ label: "Cargando...", value: null }],
    values: [],
  };

  public header: {
    title: string;
    subtitle: string;
  };

  public static createNavigation(router: Router) {
    if (environment.appName === "campanaragricola") {
      router.navigate(["dashboard/app_productos"]);
    } else {
      router.navigate(["dashboard"]);
    }
  }

  public auxMenu: any[] = [];

  public logoDashboardByUser: any;

  public urlCheckForChildren: boolean = false;

  public appName: string = environment.appName;

  public itemId: string;

  public itemsData = this.dashboardEvent.menuItemData;

  constructor(
    private router: Router,
    public dashboardEvent: DashboardService,
    private route: ActivatedRoute,
    private location: Location,
    private categoriaService: CategoriaService,
    private messageService: MessageService,
    private ImageBaseService: ImageBaseService,
    private titleHeaderService: TitleHeaderService,
    private columnService: ColumnManagerService,
    private imageConfigService: ImageConfigService
  ) {
    this.showMySideBar();

    this.titleHeaderService.changeHeaderTitle().subscribe(async (rutas) => {
      try {
        if (rutas.id) {
          let documento = await getDocumento(rutas.id);
          let listadoProcedimientos: any[] = rellenarMenUsuario();

          listadoProcedimientos = listadoProcedimientos.find(
            (data) => data.id == rutas.id
          );

          this.dashboardEvent.headerTitle = listadoProcedimientos["text"];
        } else {
          //TODO: http://localhost:5400/dashboard contain id
          // La ruta: http://localhost:5400/dashboard (Inicio) no contiene id, asignamos su titulo para el Header

          this.dashboardEvent.headerTitle = rutas.titulo || "Inicio";
        }
      } catch (error) {
        console.error("Error:", error);
      }
    });
  }
  public menuItems() {
    this.items = [
      {
        label: "Revisiones",
        icon: "pi pi-fw pi-file",
        command: (): void => {
          // this.titleAnexo = this.location.path().replace("/dashboard/", "");
          this.titleAnexo = this.commentTableName;
          let contarRutas = this.titleAnexo.split("/");
          this.displayAnexo = false;
          if (contarRutas.length != 1) {
            this.messageService.add({
              severity: "info",
              summary: "Info",
              detail:
                "Tiene que estar en un documento para poder ver las revisiones",
            });
          } else {
            this.displayAnexo = true;
          }
        },
      },
      {
        label: "Cerrar Sesión",
        icon: "fa fa-sign-out",
        command: (): void => {
          StorageManager.deleteUser();
          // localStorage.clear();
          this.router.navigate(["login"]);
        },
      },
      {
        label: "Ver " + this.version,
      },
    ];
  }

  ngAfterViewInit() {
    let datos = JSON.parse(localStorage.getItem("calidad_user_tag_1"));
    let nombre: string = datos.name;

    this.imageConfigService.updateImages(nombre);
    /*
    this.imageConfigService.currentLogoDashboard.subscribe(
      (logo) => (this.logoDashboardByUser = logo)
    );

    this.ImageBaseService.image64(this.logoDashboardByUser)
      .toPromise()
      .then((resp: string) => {
        this.logo = resp;
      });
    */
  }

  public menuItemsUser() {
    this.items = [
      {
        label: "Usuarios",
        icon: "fa fa-user",
        command: (): void => {
          this.dashboardEvent.headerTitle = "Control de usuarios";
          this.router.navigate(["dashboard/usuarios"]);
          this.dashboardEvent.isSidenavOpen.next(false);
          this.dashboardEvent.unSelectLastSubmenuItem();
          this.dashboardEvent.unSelectLastMenuItem();
          // if (this.isSidebarOpen) {
          //   this.isSidebarOpen = !this.isSidebarOpen;
          // }
        },
      },
      {
        label: "Gráfica",
        icon: "fa fa-user",
        command: (): void => {
          this.dashboardEvent.headerTitle = "Gráficas";
          this.router.navigate(["dashboard/grafica"]);
          this.dashboardEvent.isSidenavOpen.next(false);
          this.dashboardEvent.unSelectLastSubmenuItem();
          this.dashboardEvent.unSelectLastMenuItem();
        },
      },
      {
        label: "Logs",
        icon: "fa fa-id-badge",
        command: (): void => {
          this.dashboardEvent.headerTitle = "Logs";
          this.router.navigate(["dashboard/logs"]);
          this.dashboardEvent.isSidenavOpen.next(false);
          this.dashboardEvent.unSelectLastSubmenuItem();
          this.dashboardEvent.unSelectLastMenuItem();
        },
      },

      // {
      //   label: "Revisiones",
      //   icon: "fa fa-file",
      //   command: (): void => {
      //     this.dashboardEvent.isSidenavOpen.next(false);
      //     this.dashboardEvent.unSelectLastSubmenuItem();
      //     this.dashboardEvent.unSelectLastMenuItem();
      //     if (this.location.path().includes("usuarios")) {
      //       this.displayImage = true;
      //       this.expression = true;
      //       this.messageService.add({
      //         severity: "info",
      //         summary: "Usuarios",
      //         detail: "No disponible en esta sección",
      //         life: 1000,
      //       });
      //     } else {
      //       // this.titleAnexo = this.location.path().replace("/dashboard/", "");
      //       this.titleAnexo = this.commentTableName;
      //       // let contarRutas = this.titleAnexo.split("/");
      //       this.displayAnexo = false;
      //       if (this.titleAnexo === "") {
      //         this.messageService.add({
      //           severity: "info",
      //           summary: "Info",
      //           detail:
      //             "Tiene que estar en un documento para poder ver las revisiones",
      //         });
      //       } else {
      //         this.displayAnexo = true;
      //       }
      //     }
      //   },
      // },
      // {
      //   label: "Organizar columnas",
      //   icon: "fa fa-exchange",
      //   command: (): void => {
      //     this.dashboardEvent.isSidenavOpen.next(false)
      //     this.dashboardEvent.unSelectLastSubmenuItem()
      //     this.dashboardEvent.unSelectLastMenuItem()
      //     if (this.urlCheckForChildren) {
      //       this.messageService.add({
      //         severity: "error",
      //         summary: "Error",
      //         detail: "No disponible en crear/edit",
      //       });
      //       return;
      //     }
      //     if (
      //       this.location.path().includes("usuarios") ||
      //       this.location.path().includes("grafica")
      //     ) {
      //       this.displayImage = true;
      //       this.expression = true;
      //       this.messageService.add({
      //         severity: "info",
      //         summary: "Usuarios",
      //         detail: "No disponible en esta sección",
      //         life: 500,
      //       });
      //     } else {
      //       // this.titleColumnManager = this.location.path().replace("/dashboard/", "");
      //       // let contarRutas = this.titleColumnManager.split("/");
      //       this.titleColumnManager = this.commentTableName;
      //       // let contarRutas = this.titleColumnManager.split("/");
      //       this.displayColumnManager = false;
      //       if (this.titleColumnManager === "") {
      //         this.messageService.add({
      //           severity: "info",
      //           summary: "Info",
      //           detail:
      //             "Tiene que estar en un documento para poder ver las revisiones",
      //         });
      //       } else {
      //         this.displayColumnManager = true;
      //       }
      //     }
      //   },
      // },
      // {
      //   label: "Organizar formulario",
      //   icon: "fa fa-pencil-square-o",
      //   command: (): void => {
      //     this.dashboardEvent.isSidenavOpen.next(false)
      //     this.dashboardEvent.unSelectLastSubmenuItem()
      //     this.dashboardEvent.unSelectLastMenuItem()
      //     const user = JSON.parse(localStorage.getItem("calidad_user_tag_1"));
      //     if (!user || user.name !== "Locatec") {
      //       this.messageService.add({
      //         severity: "error",
      //         summary: "Acceso denegado",
      //         detail: "No tienes permiso para acceder a esta sección.",
      //       });
      //       return;
      //     }

      //     if (this.urlCheckForChildren) {
      //       this.messageService.add({
      //         severity: "error",
      //         summary: "Error",
      //         detail: "No disponible en crear/edit",
      //         life: 500,
      //       });
      //       return;
      //     }

      //     //console.log(this.location.path());

      //     if (
      //       this.location.path().includes("usuarios") ||
      //       this.location.path().includes("grafica")
      //     ) {
      //       this.displayImage = true;
      //       this.expression = true;
      //       this.messageService.add({
      //         severity: "info",
      //         summary: "Usuarios",
      //         detail: "No disponible en esta sección",
      //       });
      //     } else {
      //       this.titleFormManager = this.commentTableName;
      //       this.displayFormManager = false;
      //       if (this.titleFormManager === "") {
      //         this.messageService.add({
      //           severity: "info",
      //           summary: "Info",
      //           detail:
      //             "Tiene que estar en un documento para poder ver las revisiones",
      //         });
      //       } else {
      //         this.displayFormManager = true;
      //       }
      //     }
      //   },
      // },
      // {
      //   label: "Documentos",
      //   icon: "fa fa-file",
      //   command: (): void => {
      //     this.dashboardEvent.isSidenavOpen.next(false);
      //     this.dashboardEvent.unSelectLastSubmenuItem();
      //     this.dashboardEvent.unSelectLastMenuItem();
      //     if (this.location.path().includes("usuarios")) {
      //       this.displayImage = true;
      //       this.expression = true;
      //       this.messageService.add({
      //         severity: "info",
      //         summary: "Usuarios",
      //         detail: "No disponible en esta sección",
      //         life: 500,
      //       });
      //     } else {
      //       this.url_doc = this.location.path().replace("/dashboard/", "");
      //       this.titleDocumentacion = getDocumento(
      //         this.location.path().replace("/dashboard/", "")
      //       );

      //       let contarRutas = this.url_doc.split("/");
      //       this.displayDocumentacion = false;
      //       if (contarRutas.length != 1) {
      //         this.displayImage = true;
      //         this.expression = true;
      //         this.messageService.add({
      //           severity: "info",
      //           summary: "Info",
      //           detail:
      //             "Tiene que estar en un documento para poder añadir documentación ",
      //         });
      //       } else {
      //         this.titleDocumentacion =
      //           this.titleDocumentacion.full_title || "";
      //         this.displayDocumentacion = true;
      //       }
      //     }
      //   },
      // },
      {
        label: "Backup",
        icon: "fa fa-file-text",
        command: (): void => {
          this.dashboardEvent.isSidenavOpen.next(false);
          this.dashboardEvent.unSelectLastSubmenuItem();
          this.dashboardEvent.unSelectLastMenuItem();
          this.dashboardEvent.headerTitle = "Generar copia de seguridad";
          this.router.navigate(["dashboard/documentos"]);
        },
      },
    ];
    if (environment.showTablasMaestras && environment.showTablasMaestras.show) {
      const tablasMaestrasItems = environment.showTablasMaestras.modules.map(
        (moduleName) => {
          return this.getModuleItem(moduleName);
        }
      );
      this.items.push({
        label: "Tablas maestras",
        icon: "fa fa-file-text",
        visible: environment.showTablasMaestras.show,
        items: tablasMaestrasItems,
      });
    }

    this.items.push(
      {
        label: "Cerrar Sesión",
        icon: "fa fa-sign-out",
        command: (): void => {
          this.dashboardEvent.isSidenavOpen.next(false);
          this.dashboardEvent.unSelectLastSubmenuItem();
          this.dashboardEvent.unSelectLastMenuItem();
          StorageManager.deleteUser();
          StorageManager.removeRole();

          // localStorage.clear();
          this.router.navigate(["login"]);
        },
      },
      {
        label: "Ver " + this.version,
      }
    );
  }
  ngOnInit() {
    const currentRoute = this.router.url; // Obtiene la URL actual
    let idDocumento =
      currentRoute.split("/")[currentRoute.split("/").length - 1];
    if (idDocumento == "crear")
      idDocumento = currentRoute.split("/")[currentRoute.split("/").length - 2];
    if (idDocumento == "edit")
      idDocumento = currentRoute.split("/")[currentRoute.split("/").length - 3];
    localStorage.setItem("id_documento_registro", idDocumento);

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const currentRoute = this.router.url; // Obtiene la URL actual
        // let idDocumento =
        //   currentRoute.split("/")[currentRoute.split("/").length - 1];
        // if (idDocumento == "crear")
        //   idDocumento =
        //     currentRoute.split("/")[currentRoute.split("/").length - 2];
        // if (idDocumento == "edit")
        //   idDocumento =
        //     currentRoute.split("/")[currentRoute.split("/").length - 3];
        // localStorage.setItem("id_documento_registro", idDocumento);
        if (
          environment.appName === "campanaragricola" &&
          currentRoute === "/dashboard"
        ) {
          this.router.navigate(["dashboard/app_productos"]);
        }
      });

    // if (environment.appName === 'campanaragricola') {
    //   this.router.navigate(["dashboard/app_productos"]);
    // }
    this.isSidebarOpen = false;
    const datosUser = this.route.snapshot.data["user"];

    // const routeTestConfig = this.routeConfig.getRoutes()
    // console.log(routeTestConfig)

    /**
     *  Imagenes navegar
     */
    this.calidad_imagen = url + "upload/resource/calidad.png";
    this.certificado = url + "upload/resource/certificado.png";
    this.fruto_hueso = url + "upload/resource/fruta_hueso.jpg";
    this.app_stock = url + "upload/resource/stock.jpg";
    this.app_visitas = url + "upload/resource/visitas.jpg";
    /**
     *  Imagenes certificaciones
     */
    this.brcgs = url + "upload/resource/certificaciones/brcgs.jpg";
    this.enac = url + "upload/resource/certificaciones/enac.jpeg";
    this.global_gap = url + "upload/resource/certificaciones/global-gap.png";
    this.ifs = url + "upload/resource/certificaciones/ifs.png";
    this.igp = url + "upload/resource/certificaciones/igp.jpg";

    // let datos = JSON.parse(localStorage.getItem('calidad_user_tag_1'));
    // let nombre: string = datos.name;
    // if (nombre.localeCompare('Locatec') == 0) {
    //   this.logoDashboardByUser = urlUpload + "/logo.jpg";
    // } else if (nombre.localeCompare('FNDB') == 0) {
    //   this.logoDashboardByUser = urlUpload + "/logo-fndb.png";
    // } else {
    //  this.logoDashboardByUser = urlUpload + "/logo.jpg";
    // }

    if (datosUser) {
      const nombre: string = datosUser.name;

      if (environment.appName === "campanaragricola") {
        this.imageConfigService.updateImages("Locatec");
      } else {
        this.imageConfigService.updateImages(nombre);
      }

      /*
      this.imageConfigService.currentLogoDashboard.subscribe((logo) => {
        this.logoDashboardByUser = logo;

        this.ImageBaseService.image64(this.logoDashboardByUser)
          .toPromise()
          .then((resp: string) => {
            this.logo = resp;
          });
      });
      */
    }

    //  let datos = JSON.parse(localStorage.getItem('calidad_user_tag_1'));
    //  let nombre: string = datos.name;

    //   console.log(nombre)

    //  this.imageConfigService.updateImages(nombre);

    //  this.imageConfigService.currentLogoDashboard.subscribe(logo => this.logoDashboardByUser = logo)

    //  this.ImageBaseService.image64(this.logoDashboardByUser)
    //     .toPromise()
    //     .then((resp: string) => {
    //       this.logo = resp;
    //     });

    this.setOnlineService();
    this.showImage();

    /* this.fechaSpanish(); */

    // this.router.events
    //   .pipe(filter((event) => event instanceof NavigationEnd))
    //   .subscribe(() => {
    //       console.log('Cambio de ruta')
    //       this.updateRouteData();
    //   });

    // this.updateRouteData();

    this.auxMenu = rellenarMenUsuario();

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.updateRouteData();
      });
    this.updateRouteData();
  }

  private setOnlineService() {
    this.isOnline = navigator.onLine;

    window.addEventListener("online", () => {
      this.isOnline = true;
    });

    window.addEventListener("offline", () => {
      this.isOnline = false;
    });
  }

  public onNavItemClick(id: string) {
    this.dashboardEvent.onMenuItemClick(id);

    // if (localStorage.getItem("role").localeCompare("ROLE_ADMIN") != 0 && localStorage.getItem('role').localeCompare("ROLE_USER") != 0) {
    //   this.isSidebarOpen = !this.isSidebarOpen;
    // }

    let idProc: string = "";
    idProc = getDocumentoFirstReport(id);
    localStorage.setItem("id_documento_registro", idProc);

    //this.isSidebarOpen = !this.isSidebarOpen;
  }

  public onSubNavItemClick(id: string) {
    localStorage.setItem("id_documento_registro", id);
    this.dashboardEvent.onMenuItemClick(id);
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  // public toggleMenu(menu?: any, $event?: any) {
  //   this.isSidebarOpen = !this.isSidebarOpen;
  // }
  toggleMenu() {
    this.isSidebarOpen = !this.isSidebarOpen;
    if (this.isSidebarOpen) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
  }

  public clickItemMenu($event?: any) {
    //menu.toggle($event);
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  public closeClientDialog() {
    this.showClientDialog = false;
    this.clientHeaderDialog = "Cambiar cliente";
  }

  public prefsMenu() {
    //console.log("Abre preferencias!");
  }

  public exit() {
    StorageManager.deleteUser();
    localStorage.setItem("documentos", null);
    this.dashboardEvent.deleteMenu();

    // localStorage.clear();
    this.router.navigate(["login"]);
  }

  public showImage() {
    this.displayImage = false;
    this.expression = false;
    let contarRutas = this.location.path().split("/");
    //let contarArrayRutas=contarRutas.length;

    if (contarRutas.length > 2) {
      this.displayImage = false;
      this.expression = false;
    } else {
      this.displayImage = true;
      this.expression = true;
    }
  }
  public showMySideBar() {
    let contarRutas = this.location.path().split("/");
    //let contarArrayRutas=contarRutas.length;

    if (contarRutas.length > 2) {
      this.isSidebarOpen = false;
    } else {
      this.isSidebarOpen = true;
    }
  }
  restriccionAnexos() {
    // this.titleAnexo = this.location.path().replace("/dashboard/", "");
    this.titleAnexo = this.commentTableName;
    let contarRutas = this.titleAnexo.split("/");
    this.displayAnexo = false;
    this.displayDocumentacion = false;
    if (contarRutas.length != 1) {
    }
  }
  public anexos(menu) {
    this.items = [];
    // this.titleAnexo = this.location.path().replace("/dashboard/", "");
    this.titleAnexo = this.commentTableName;
    // let contarRutas = this.titleAnexo.split("/");
    this.displayAnexo = false;
    this.menuItems();
    menu.toggle(event);
    if (localStorage.getItem("role") == "ROLE_ADMIN") {
      //this.menuItems();
      this.menuItemsUser();
      //menu.toggle(event);
      /*        this.items.push({
                       label: 'Usuarios',
                       icon: 'pi pi-fw pi-user',
                       command: (): void => {

                         this.router.navigate(['dashboard/usuarios']);
                     }


                   },{
                       label: 'Cerrar Sesión',
                   icon: 'fa fa-sign-out',
                   command: (): void => {
                       StorageManager.deleteUser();
                       this.router.navigate(['login']);
                   }
               }); */
    }
    if (this.location.path().includes("usuarios")) {
    } else {
      if (localStorage.getItem("role") == "ROLE_ADMIN") {
        //this.menuItems();
        this.menuItemsUser();
        //menu.toggle(event);
        /*        this.items.push({
                           label: 'Usuarios',
                           icon: 'pi pi-fw pi-user',
                           command: (): void => {

                             this.router.navigate(['dashboard/usuarios']);
                         }


                       },{
                           label: 'Cerrar Sesión',
                       icon: 'fa fa-sign-out',
                       command: (): void => {
                           StorageManager.deleteUser();
                           this.router.navigate(['login']);
                       }
                   }); */
      }
      if (this.titleAnexo && localStorage.getItem("role") != "ROLE_ADMIN") {
        //this.displayAnexo=true;
        this.categoria = this.titleAnexo;
        this.categoryColumnManager = this.commentTableName;

        /*  this.items.push({
                     label: 'Anexos',
                     icon: 'pi pi-fw pi-file',
                     command: (): void => {

                       this.displayAnexo=true;
                   }
                 }); */
      } else {
        this.displayAnexo = false;
        this.displayDocumentacion = false;
        if (localStorage.getItem("role") == "ROLE_ADMIN") {
        } else {
          // this.displayImage=true;
          // this.messageService.add({severity:'info', summary: 'Info', detail:'Tiene que estar en un documento para poder ver los anexos'});
        }
      }
    }
  }

  cerrar() {
    this.displayAnexo = false;
    this.displayDocumentacion = false;
    this.displayColumnManager = false;
    this.displayFormManager = false;
  }

  toDataUrl(url, callback) {
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
      var reader = new FileReader();
      reader.onloadend = function () {
        callback(reader.result);
      };
      reader.readAsDataURL(xhr.response);
    };
    xhr.open("GET", url);
    xhr.responseType = "blob";
    xhr.send();
  }

  navegar(value) {
    //this.onSubNavItemClick(value);
    this.isSidebarOpen = false;
    this.router.navigate(["dashboard/" + value]);
  }

  stock() {
    window.open(" http://demo.qualitapp.com", "_blank");
  }
  visitas() {
    window.open(" http://traza-brio.com/visitas", "_blank");
  }

  checkRoleUser() {
    if (localStorage.getItem("role").localeCompare("ROLE_USER") == 0) {
      this.displayDocumentacion = true;
      return true;
    }
    return false;
  }

  checkRoleAdmin() {
    if (localStorage.getItem("role").localeCompare("ROLE_ADMIN") == 0) {
      this.displayDocumentacion = true;
      return true;
    }
    return false;
  }

  // private updateRouteData() {

  //   const nameUrl = this.location.path().replace("/dashboard/", "");
  //   const dashboardRoute = routes.find((route) => route.path === "dashboard");
  //   if (dashboardRoute) {
  //     const children = dashboardRoute.children.find(
  //       (child) => child.path === nameUrl
  //     );
  //     let childrenDatabase = ''

  //     if (children && children.data) {
  //       childrenDatabase = children.data.database || "";
  //     } else {
  //       childrenDatabase = "";
  //     }
  //     childrenDatabase = childrenDatabase || nameUrl;

  //     if (childrenDatabase) {
  //       this.obtainTableComment(childrenDatabase)
  //     }
  //   }
  // }

  // private updateRouteData() {
  //   if (this.route.snapshot.firstChild){
  //     console.log(this.route.snapshot)
  //     const nameUrl = this.route.snapshot.firstChild.routeConfig.path;
  //     let childrenDatabase = this.route.snapshot.firstChild.data.database ? this.route.snapshot.firstChild.data.database : nameUrl;
  //     if (childrenDatabase) {
  //       this.obtainTableComment(childrenDatabase);
  //     }
  //   }
  // }

  // Compares url child with procedimientos array, it will obtain database if exists or id
  // Then it will call obtainTableComment to obtain comment of table
  private updateRouteData(): void {
    const nameUrl = this.location.path().replace("/dashboard/", "");
    if (nameUrl.includes("/crear") || nameUrl.includes("/edit")) {
      this.urlCheckForChildren = true;
    } else {
      this.urlCheckForChildren = false;
    }

    const firstChildRoute = this.route.snapshot.firstChild;
    if (firstChildRoute) {
      const nameUrl = firstChildRoute.routeConfig.path;
      const valueUrl = this.auxMenu.find((url) => url.id === nameUrl);
      if (valueUrl === undefined) {
        return;
      }

      const tableName = valueUrl.database ? valueUrl.database : valueUrl.id;
      if (tableName) {
        this.obtainTableComment(tableName);
      }
    }
  }

  async obtainTableComment(tableName: string): Promise<void> {
    if (environment.appName === "campanaragricola") {
      return;
    }
    try {
      const response: any = await this.columnService
        .fetchTableComment(tableName)
        .toPromise();
      if (
        response.status === 200 &&
        response.table_comment != null &&
        response.table_comment !== ""
      ) {
        this.commentTableName = response.table_comment;
      } else {
        this.commentTableName = tableName;
      }
    } catch (error) {
      console.error("Error:", error);
    }
  }

  private getModuleItem(moduleName: string): any {
    const moduleMap = {
      variedades: {
        label: "Variedades",
        headerTitle: "Variedades",
        icon: "pi fa fa-apple",
        route: "dashboard/variedades",
      },
      productos_camion: {
        label: "Prod. camión",
        headerTitle: "Productos camión",
        icon: "fa fa-product-hunt",
        route: "dashboard/prod_camion",
      },
      paises: {
        label: "Países",
        headerTitle: "Países",
        icon: "pi fa fa-globe",
        route: "dashboard/paises",
      },
      empresas: {
        label: "Empresas",
        headerTitle: "Empresas",
        icon: "pi fa fa-industry",
        route: "dashboard/empresas",
      },
      almacenes: {
        label: "Almacenes",
        headerTitle: "Almacenes",
        icon: "pi fa fa-industry",
        route: "dashboard/almacenes",
      },
      prod_post_cosecha: {
        label: "Prod. post cosecha",
        headerTitle: "Prod post cosecha",
        icon: "fa fa-file-text",
        route: "dashboard/prod_post_cosecha",
      },
      calibre: {
        label: "Calibre",
        headerTitle: "Calibre",
        icon: "pi fa fa-cog",
        route: "dashboard/calibre",
      },
      materia_activa: {
        label: "Materia activa",
        headerTitle: "Materia activa",
        icon: "pi fa fa-flask",
        route: "dashboard/materia_activa",
      },
      tipo_de_residuos: {
        label: "Tipos de residuos",
        headerTitle: "Tipos de residuos",
        icon: "pi fa fa-trash",
        route: "dashboard/tipo_residuos",
      },
      ubicacion: {
        label: "Ubicación",
        headerTitle: "Ubicación",
        icon: "pi fa fa-map",
        route: "dashboard/ubicacion",
      },
    };

    const module = moduleMap[moduleName];
    return {
      label: module.label,
      icon: module.icon,
      command: (): void => {
        (this.dashboardEvent.headerTitle = module.headerTitle),
          this.router.navigate([module.route]);

        this.dashboardEvent.isSidenavOpen.next(false);
        this.dashboardEvent.unSelectLastSubmenuItem();
        this.dashboardEvent.unSelectLastMenuItem();
      },
    };
  }
}
